import React, { useEffect, useState } from "react";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import { useParams, Link } from "react-router-dom";
import Logo from '../assets/logo.png';
import axios from "axios";

const API_BASE =
  import.meta.env?.VITE_API_BASE ||
  process.env.REACT_APP_API_BASE ||
  "https://rfs2.infraconsoft.net.in/api";

const API_ORIGIN = API_BASE.replace(/\/api\/?$/, "");


const PurchaseOrder_print = () => {
  
    const {poNo} = useParams();
  const branch = localStorage.getItem("branch");
  const [poDetail, setPoDetail] = useState({});
    const [data, setData] = useState([]);
    const [data1, setData1] = useState([]);
    const [showModal, setShowModal] = useState(false);

  const [subDetails, setSubDetails] = useState({})


   const [site, setSite] = useState({
    ok: true,
    name: "Infraconsoft",
    logo: null,
    address: "",
    email: "",
    phone: "",
    _ts: 0,
  });

  // Fetch site/company info
  useEffect(() => {
    let ignore = false;
    (async () => {
      try {
        const res = await axios.get(`${API_BASE}/siteinfo`);
        const s = res?.data || {};
        // ensure absolute logo URL if server ever returns relative
        let logo = s.logo || null;
        if (logo && !/^https?:\/\//i.test(logo)) {
          if (!logo.startsWith("/")) logo = `/${logo}`;
          logo = `${API_ORIGIN}${logo}`;
        }
        if (!ignore) {
          setSite({
            ok: !!s.ok,
            name: s.name || "Infraconsoft",
            logo,
            address: s.address || "",
            email: s.email || "",
            phone: s.phone || "",
            _ts: Date.now(),
          });
        }
      } catch (e) {
        // keep defaults on failure
        console.error("Failed to load /siteinfo", e);
      }
    })();
    return () => {
      ignore = true;
    };
  }, []);


  useEffect(() => {
    const fetchIndentDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/bopurchaseOrder_BilldetailsHeader?poNo=${poNo}&branch=${branch}`);
        if (response.data && response.data.headerDetails?.length > 0) {
            const items = response.data.headerDetails;

            const storeReqHeader = {
                purchaseOrderHeader_suppliercode: items[0].purchaseOrderHeader_suppliercode || "N/A",
                purchaseOrderHeader_podate: items[0].purchaseOrderHeader_podate || "N/A",
                purchaseOrderHeader_supplierName: items[0].purchaseOrderHeader_supplierName || "N/A",
                purchaseOrderHeader_yourReferenceNumber: items[0].purchaseOrderHeader_yourReferenceNumber || "N/A",
                purchaseOrderHeader_yourReferenceDate: items[0].purchaseOrderHeader_yourReferenceDate || "N/A",
                purchaseOrderHeader_ourReferenceNumber: items[0].purchaseOrderHeader_ourReferenceNumber || "N/A",
                purchaseOrderHeader_ourReferenceDate: items[0].purchaseOrderHeader_ourReferenceDate || "N/A",
                purchaseOrderHeader_value: items[0].purchaseOrderHeader_value || "N/A",
                purchaseOrderHeader_discount: items[0].purchaseOrderHeader_discount || "N/A",
                purchaseOrderHeader_pfcharges: items[0].purchaseOrderHeader_pfcharges || "N/A",
                purchaseOrderHeader_freightCharges: items[0].purchaseOrderHeader_freightCharges || "N/A",
                purchaseOrderHeader_totalValue: items[0].purchaseOrderHeader_totalValue || "N/A",
                PurchaseOrderHeader_Transport: items[0].PurchaseOrderHeader_Transport || "N/A",
                purchaseOrderHeader_paymentTerms: items[0].purchaseOrderHeader_paymentTerms || "N/A",
                purchaseOrderHeader_deliveryMethod: items[0].purchaseOrderHeader_deliveryMethod || "N/A",
                purchaseOrderHeader_deliveryPlace: items[0].purchaseOrderHeader_deliveryPlace || "N/A",
                PurchaseOrderHeader_PriceBasis: items[0].PurchaseOrderHeader_PriceBasis || "N/A",
                purchaseOrderHeader_remarks: items[0].purchaseOrderHeader_remarks || "N/A",
                purchaseOrderHeader_CSTtax: items[0].purchaseOrderHeader_CSTtax || "N/A",
                branchCode: items[0].branchCode || "N/A",
                userId: items[0].userId || "N/A",
                
            };

            setPoDetail(storeReqHeader);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchIndentDetails();
  }, [poNo, branch]); 

  useEffect(() => {
    const fetchSupplierDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/purchaseOrder_supDetails?supplierCode=${poDetail.purchaseOrderHeader_suppliercode}`);
            const items = response.data.supDetails;
            console.log(response.data.supDetails);
            
            const storeReqHeaderCity = {
                supplierMaster_addressline1 : items[0].supplierMaster_addressline1 || "N/A",
                supplierMaster_addressline2 : items[0].supplierMaster_addressline2 || "N/A",
                supplierMaster_city : items[0].supplierMaster_city || "N/A",
                supplierMaster_pincode : items[0].supplierMaster_pincode || "N/A",
                
            };
            setSubDetails(storeReqHeaderCity);
            // setData(response.data.supDetails);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchSupplierDetails();
  }, [poDetail.purchaseOrderHeader_suppliercode]); 



  useEffect(() => {
    axios.get(`https://rfs2.infraconsoft.net.in/api/bopurchaseOrder_billdetailsBottom?branch=${branch}&poNo=${poNo}`)
      .then((response) => {
        if (response.data && response.data.headerDetails2) {
          setData(response.data.headerDetails2);
          console.log(response.data.headerDetails2);
          
        } else {
          setData([]); 
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setData([]); 
      });
  }, [branch, poNo]);

  const handlePrint = () => {
    window.print();
  };

  const logoSrc = site.logo ? `${site.logo}${site._ts ? `?v=${site._ts}` : ""}` : Logo;
    return (
        <div className="delivery-note-container">
            {/* Header Section */}

            
            <div className="prPrint-header">
        <img src={logoSrc} alt={`${site.name} Logo`} className="prPrint-logo" />
        <div className="prPrint-company-details">
          <h2 style={{ textTransform: "uppercase" }}>{site.name || "Infraconsoft"}</h2>
          {site.address && <p>{site.address}</p>}
          {(site.phone || site.email) && (
            <p>
              {site.phone && <span>Ph: {site.phone}</span>}
              {site.phone && site.email && <span> | </span>}
              {site.email && <span>Email: {site.email}</span>}
            </p>
          )}
        </div>
      </div>

            {/* Delivery Details */}
            <div className="delivery-details">
                <div className="left">
                    <p><strong>Supplier Code:</strong> {poDetail.purchaseOrderHeader_suppliercode || "N/A"}</p>
                    <p><strong>Supplier Name:</strong> {poDetail.purchaseOrderHeader_supplierName || "N/A"}</p>
                    <p><strong>Address 1:</strong> {subDetails.supplierMaster_addressline1 || "N/A"}</p>
                    <p><strong>Address 2:</strong> {subDetails.supplierMaster_addressline2 || "N/A"}</p>
                    <p><strong>City:</strong> {subDetails.supplierMaster_city || "N/A"}</p>
                    <p><strong>Pin code:</strong> {subDetails.supplierMaster_pincode || "N/A"}</p>
                </div>
                <div className="right">
                    <p><strong>Purchase Order No:</strong> {poNo || "N/A"}</p>
                    <p><strong>PO. Date:</strong> {poDetail.purchaseOrderHeader_podate ? new Date(poDetail.purchaseOrderHeader_podate).toLocaleDateString("en-GB") : ""}</p>
                    <p><strong>Your Ref No:</strong> {poDetail.purchaseOrderHeader_yourReferenceNumber}</p>
                    <p><strong>Your Ref Date:</strong> {poDetail.purchaseOrderHeader_yourReferenceDate ? 
         new Date(poDetail.purchaseOrderHeader_yourReferenceDate).toLocaleDateString("en-GB") : ""}</p>
                    <p><strong>Our Ref No:</strong> {poDetail.purchaseOrderHeader_ourReferenceNumber || "N/A"}</p>
                    <p><strong>Our Ref Date:</strong> {poDetail.purchaseOrderHeader_ourReferenceDate ? new Date(poDetail.purchaseOrderHeader_ourReferenceDate).toLocaleDateString("en-GB") : ""}</p>
                    <p><strong>Branch:</strong> {poDetail.branchCode || "N/A"}</p>
                    <p><strong>Prepared By:</strong> {poDetail.userId || "N/A"}</p>
                    
                </div>
            </div>

            {/* Items Table */}
            <table className="items-table">
                <thead>
                    <tr>
                    <th>S.No</th>
                        <th>Item</th>
                        <th>Part No</th>
                        <th>Description</th>
                        <th>Qty</th>
                        <th>Uom</th>
                        <th>Price</th>
                        <th>GST%</th>
                        <th>PF%</th>
                        <th>Disc%</th>
                        <th>Value</th>
                    </tr>
                </thead>
                <tbody>
                    {data.length > 0 ? (
                        data.map((item, index) => (
                            <tr key={index}>
                                 <td>{index + 1}</td>
                                <td>{item?.purchaseOrderDetail_itemCode || "N/A"}</td>
                                <td>{item?.itemmaster_drawingNumber || "N/A"}</td>
                                <td>{item?.itemmaster_name || "N/A"}</td>
                                <td>{item?.purchaseOrderDetail_orderedQuantity || 0}</td>
                                <td>{item?.itemMaster_purchaseUom || 0}</td>
                                <td>{item?.purchaseOrderDetail_price || 0}</td>
                                <td>{item?.purchaseOrderDetail_CSTtax || "N/A"}</td>
                                <td>{item?.purchaseOrderDetail_PFpercentage || "N/A"}</td>
                                <td>{item?.purchaseOrderDetail_discountPercentage || "N/A"}</td>
                                <td>{item?.purchaseOrderDetail_value || "N/A"}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="8" style={{ textAlign: "center" }}>No items found</td>
                        </tr>
                    )}
                </tbody>
            </table>

           
            <h2>Bill Details</h2>
            {/* Items Table */}
            <table className="items-table bill">
                <tbody>
                   
                            <tr>
                                <td>Sub Total</td>
                                <td>₹{parseFloat(poDetail.purchaseOrderHeader_value || 0).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>GST (18%)</td>
                                <td>₹{parseFloat(poDetail.purchaseOrderHeader_CSTtax || 0).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>Disc (%)</td>
                                <td>₹{parseFloat(poDetail.purchaseOrderHeader_discount || 0).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>PF</td>
                                <td>₹{parseFloat(poDetail.purchaseOrderHeader_pfcharges || 0).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>Fright Charges</td>
                                <td>₹{parseFloat(poDetail.purchaseOrderHeader_freightCharges || 0).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>Payment Terms</td>
                                <td>{poDetail.purchaseOrderHeader_paymentTerms}</td>
                            </tr>
                            <tr>
                                <td>Delivery Method</td>
                                <td>{poDetail.purchaseOrderHeader_deliveryMethod}</td>
                            </tr>
                            <tr>
                                <td>Remarks</td>
                                <td>{poDetail.purchaseOrderHeader_remarks}</td>
                            </tr>
                            <tr>
                                <td>Total</td>
                                <td>₹{parseFloat(poDetail.purchaseOrderHeader_totalValue || 0).toFixed(2)}</td>
                            </tr>

                </tbody>
            </table>
            <div style={{ textAlign: "center", marginTop: "20px" }}>


      <button
        onClick={handlePrint}
        style={{
          backgroundColor: "#4a90e2",
          color: "white",
          border: "none",
          padding: "12px 24px",
          fontSize: "16px",
          cursor: "pointer",
          borderRadius: "8px",
          transition: "background 0.3s ease-in-out",
          marginTop: "20px",
        }}
      >
        Print
      </button>
    </div>

            
        </div>
    );
};

export default PurchaseOrder_print;
